import apiClient from './apiClient'

export const actionNames = {
  INIT_SUBSCRIPTION: 'initGroup',
  INIT_MEMBERS: 'initMembers',
  ADD_MEMBER: 'addMember',
  REMOVE_MEMBER: 'removeMember',
  RESEND_INVITATION: 'resendInvitation'
}

export const module = {
  state: {
    subscription: {},
    members: []
  },
  mutations: {
    setSubscription (state, subscription) {
      state.subscription = subscription
    },
    setMembers (state, members) {
      state.members = members
    },
    addMember (state, newMember) {
      state.members = [...state.members, newMember]
    },
    deleteMemberById (state, memberIdToDelete) {
      state.members = state.members.filter(m => m.id !== memberIdToDelete)
    }
  },
  actions: {
    async [actionNames.INIT_SUBSCRIPTION] ({ commit, rootState }) {
      commit('setSubscription', await apiClient.getSubscription(rootState.auth.clientId))
    },
    async [actionNames.INIT_MEMBERS] ({ commit, rootState }) {
      commit('setMembers', await apiClient.getMembers(rootState.auth.clientId))
    },
    async [actionNames.ADD_MEMBER] ({ commit, rootState }, email) {
      commit('addMember', await apiClient.addMember(rootState.auth.clientId, email))
    },
    async [actionNames.REMOVE_MEMBER] ({ commit, rootState }, memberId) {
      await apiClient.removeMember(rootState.auth.clientId, memberId)
      commit('deleteMemberById', memberId)
    },
    async [actionNames.RESEND_INVITATION] ({ rootState }, memberId) {
      await apiClient.resendInvitation(rootState.auth.clientId, memberId)
    }
  }
}
